"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-chat-16><path d="M5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path><path fill-rule=evenodd clip-rule=evenodd d="M0 4a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3v1.99a.998.998 0 0 1-1.515.868L6.723 13H3a3 3 0 0 1-3-3V4Zm13 7h-2v2.234l-3.464-2.079A.995.995 0 0 0 7 11H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1Z"></path></symbol>';
}
